import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CardTagLine extends Component {
  static propTypes = {
    tags: PropTypes.array,
    maxTags: PropTypes.number,
    keyIdentifier: PropTypes.string.isRequired,
    seeMoreURL: PropTypes.string,
    className: PropTypes.string,
    tagClassName: PropTypes.string,
  };

  static defaultProps = {
    tags: [],
    seeMoreUrl: null,
    maxTags: 4,
    tagClassName: 'u-topic',
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  sortTags(tags) {
    return tags.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
  }

  expand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ expanded: true });
  };

  collapse = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ expanded: false });
  };

  renderTags = () => {
    const maxTags = this.state.expanded ? this.props.tags.length : this.props.maxTags;
    const shownTags = this.sortTags(this.props.tags);

    const tags = [];
    for (let i = 0; i < maxTags; i++) {
      if (shownTags.length > i) {
        tags.push(
          <div
            className={this.props.tagClassName}
            key={`${this.props.keyIdentifier}-${shownTags[i].id}`}>
            {shownTags[i].name}
          </div>
        );
      }
    }

    if (shownTags.length > maxTags || this.state.expanded) {
      const xMore = `+ ${shownTags.length - maxTags} more`;
      tags.push(
        <div className="Card-moreTags" key={`${this.props.keyIdentifier}-showmore`}>
          {this.props.seeMoreURL && (
            <a className="u-cursor-pointer" href={this.props.seeMoreURL}>
              {xMore}
            </a>
          )}
          {!this.props.seeMoreURL && !this.state.expanded && (
            <a className="u-cursor-pointer" onClick={this.expand}>
              {xMore}
            </a>
          )}
          {this.state.expanded && (
            <a className="u-cursor-pointer" onClick={this.collapse}>
              See less
            </a>
          )}
        </div>
      );
    }

    if (tags.length > 0) {
      return <div className={`Card-tagLine ${this.props.className}`}>{tags}</div>;
    }

    return null;
  };

  render() {
    return this.renderTags();
  }
}
